import { useState } from "react";
const useInputs = () => {
    const [useFragment, setUseFragment] = useState(false);
    const [shortened, setShortened] = useState();
    const [shortenError, setShortenError] = useState();
    const [hasWarning, setHasWarning] = useState(false);
    return {
        useFragment,
        setUseFragment,
        shortened,
        setShortened,
        shortenError,
        setShortenError,
        hasWarning,
        setHasWarning,
    };
};
export default useInputs;
